<template>
  <div>
    <md-list :class="`md-triple-line md-dense `">
      <md-list-item @click="onSelect" :class="`tournament ${state}`">
        <div class="tournament-day">{{day}}</div>
        <div class="md-list-item-text">
          <span class="tournament-name">{{tournament.name}}</span>
          <p>
            <span>{{ dates }}</span>
          </p>
          <p v-if="tournament.location">
            <span>{{ tournament.location.name }}</span>
          </p>
        </div>
        <img class="sport" :src="icon(tournament)">
      </md-list-item>
      <md-tooltip>{{details}}</md-tooltip>
    </md-list>
  </div>
</template>

<style lang="scss" scoped>
.tournament-day {
  padding-right: 1em;
  width: 3em;
  float: left;
  font-weight: bold;
  font-size: 2em;
  text-align: right;
}

.tournament-name {
  font-weight: bold;
  font-size: larger !important;
}

.tournament {
  width: 360px;
  //  margin: 0;
  border-radius: 1em;
  border: solid;
}

.sport {
  padding-left: 1em;
}

.PAST {
  background-color: rgb(201, 117, 117);
}
.FUTURE {
  background-color: rgb(111, 111, 184);
}
.NOW {
  background-color: rgb(72, 139, 72);
}
</style>

<script>
import moment from "moment";
import { TournamentTools } from "@/js/helper";

export default {
  name: "TournamentEntry",
  props: { tournament: Object },
  computed: {
    day: {
      get() {
        return this.tournament.startDate
          ? `${moment(this.tournament.startDate).format("Do")}`
          : "?";
      }
    },
    dates: {
      get() {
        if (
          this.tournament.startDate &&
          this.tournament.endDate &&
          this.tournament.startDate != this.tournament.endDate
        )
          return `${this.formatDate(
            this.tournament.startDate
          )} - ${this.formatDate(this.tournament.endDate)}`;
        return this.tournament.startDate
          ? this.formatDate(this.tournament.startDate)
          : "?";
      }
    },
    details: {
      get() {
        const result = [];
        result.push(this.dates);
        if (this.tournament.description)
          result.push(this.tournament.description);
        if (this.tournament.circuit) result.push(this.tournament.circuit);
        if (this.tournament.format) result.push(this.tournament.format);

        return result.join(", ");
      }
    },
    state: {
      get() {
        const now = moment().startOf("day");
        const d = moment(this.tournament.startDate).startOf("day");
        if (d < now) return "PAST";
        if (now < d) return "FUTURE";
        return "NOW";
      }
    }
  },
  methods: {
    icon: TournamentTools.icon,
    formatDate(d) {
      const m = moment(d);
      if (m.hour() === 0 && m.minute() === 0) return m.format("ddd MMM Do");
      return m.format("ddd MMM Do @ HH:mm");
    },
    onSelect(event) {
      this.$store.commit("pushToRecentTournamentId", {
        id: this.tournament.id,
        name: this.tournament.name
      });
      this.$router.push({ path: "/tournament" });
    }
  }
};
</script>




// WEBPACK FOOTER //
// tournamentEntry.vue?755b1ea0